<template>
  <div class="content modals-start-over">
    <div v-if="$store.state.utils.configuration.enableNewStartOverModal">
      <div class="row">
        <p class="new-modal-description">
          {{ translations.startOverDescription1 }}
          <br />
          {{ translations.startOverDescription2 }}
        </p>
      </div>
      <div class="row">
        <img v-show="imageUrl && !showSpinner" class="modals-start-over-img" :src="imageUrl" :alt="pdm.product_name" @load="hideSpinner(true)" />
      </div>
      <base-spinner v-show="showSpinner"></base-spinner>
    </div>
    <div v-else >
      <h5 class="text-center subheader">
        {{ translations.startOverSubHeader1 }}
        <br />
        {{ translations.startOverSubHeader2 }}
      </h5>
      <div class="modal-img-wrapper modals-start-over-wrapper">
        <base-spinner v-show="showSpinner"></base-spinner>
        <img
          class="modals-start-over-wrapper-img"
          @load="hideSpinner(true)"
          :src="imageUrl"
          :alt="pdm.product_name"
          v-show="imageUrl && !showSpinner"
        />
      </div>
    </div>
  </div>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import startOver from '@/mixins/StartOver';

export default {
  name: "StartOverModal",
  components: {
    baseSpinner
  },
  mixins: [startOver],
  methods: {
    /**
     * @function ctaAction
     * Method to be called from parent component from CTA button.
     */
    ctaAction() {
      const { initRecipe, defaultRecipe, recipeId } = this.$store.state.recipe;
      let url = window.location.href;
      if(initRecipe.recipe_id !== defaultRecipe.recipe_id && !url.includes("recipe")) {
        url = url.includes("?") ? `${url}&recipe=${initRecipe.recipe_id}`
          : `${url}?recipe=${initRecipe.recipe_id}`;
      }


      this.$store.getters['utils/vsfActive'] && this.$eventBus.$emit('customsStartOver');

      if (this.$store.getters['utils/canvasActive']) {
        this.$iframeCommunicator.postMessage({ command: 'startOver' });
        window.parent.location.reload();
      } else {
        window.location = url;
      }
    }
  },
  created() {
    this.beforeOpenModal();
  }
};
</script>
